import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import { IconAlert } from '../../1-foundation/icons/icons';
import SectionTitle from '../../2-atoms/section-title/section-title';
import DropdownFloating from '../dropdown/dropdown-floating';

const DEFAULT_MODIFIERS = [];
const SECTION_TITLE_MODIFIERS = ['border-dark'];

const SkyItBox = ({
  children,
  modifiers = DEFAULT_MODIFIERS,
  title,
  description,
  onInfoClick,
  options,
  image,
  Footer,
}) => {
  const classNames = getClassNames('c-sky-it-box', [...modifiers, image && 'with-image']);

  return (
    <div className={classNames}>
      <div className="c-sky-it-box__header">
        <div className="c-sky-it-box__title">
          {image && (
            <div className="c-sky-it-box__image">
              <img src={image} />
            </div>
          )}
          <SectionTitle tag="h3" modifiers={SECTION_TITLE_MODIFIERS}>
            {title}
          </SectionTitle>
          {onInfoClick && (
            <IconAlert
              modifiers={['c-neutral', 'alert', 'small']}
              classNames="c-sky-it-box__alert-icon"
              onClick={onInfoClick}
            />
          )}
        </div>
        {Boolean(options?.length) && <DropdownFloating options={options} />}
      </div>
      {description && <p className="c-sky-it-box__description" dangerouslySetInnerHTML={{ __html: description }} />}
      {children}
      {Footer && <Footer />}
    </div>
  );
};

SkyItBox.propTypes = {
  children: PropTypes.any.isRequired,
  modifiers: PropTypes.array,
  title: PropTypes.string,
  description: PropTypes.string,
  onInfoClick: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      href: PropTypes.string,
      intcmp: PropTypes.string,
    })
  ),
  image: PropTypes.string,
  Footer: PropTypes.node,
};

export default SkyItBox;
